export default __webpack_public_path__ + "static/media/CSS.19c8605d.png";